"use client";

import { setEnvelopeDropObserver, type EnvelopeDropEvent } from "@zzk/api";
import type { ClientErrorReporter } from "@zzk/ui";

function dropReason(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string" && error.length > 0) return error;
  return "Envelope row failed schema validation.";
}

export function installEnvelopeDropTelemetry(
  reporter: ClientErrorReporter,
): () => void {
  return setEnvelopeDropObserver((event: EnvelopeDropEvent) => {
    void reporter.report({
      severity: "warning",
      message: `Envelope row dropped at index ${event.index} of ${event.totalRows}.`,
      source: { component: "envelope", route: event.source ?? null },
      tags: { kind: "envelope-drop" },
      details: { index: event.index, totalRows: event.totalRows, reason: dropReason(event.error) },
    });
  });
}
